import { useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import IosShareRounded from '@mui/icons-material/IosShareRounded';
import AddBoxOutlined from '@mui/icons-material/AddBoxOutlined';
import { ehSafariIos } from './instalacao';

// Passo a passo de instalação no iPhone/iPad (ver formaInstalacao em
// instalacao.ts): lá não existe instalador automático, só o menu
// Compartilhar do Safari.
interface IDialogInstalarIosProps {
  open: boolean;
  onClose: () => void;
}

const Passo: React.FC<{ numero: number; children: React.ReactNode }> = ({ numero, children }) => (
  <Box display="flex" gap={1.5} alignItems="flex-start" sx={{ mb: 1.5 }}>
    <Box
      sx={{
        minWidth: 24, height: 24, borderRadius: '50%', bgcolor: 'primary.main', color: 'primary.contrastText',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700,
      }}
    >
      {numero}
    </Box>
    <Typography variant="body2" component="div" sx={{ pt: 0.25 }}>{children}</Typography>
  </Box>
);

export const DialogInstalarIos: React.FC<IDialogInstalarIosProps> = ({ open, onClose }) => {
  const [copiado, setCopiado] = useState(false);
  const noSafari = ehSafariIos();

  const copiarEndereco = async () => {
    try {
      await navigator.clipboard.writeText(window.location.origin);
      setCopiado(true);
    } catch {
      setCopiado(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Instalar o SIAC no iPhone</DialogTitle>
      <DialogContent>
        {!noSafari && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            No iPhone o SIAC só pode ser instalado pelo <b>Safari</b>. Copie o endereço e abra no Safari.
            <Box sx={{ mt: 1 }}>
              <Button size="small" variant="outlined" onClick={copiarEndereco}>
                {copiado ? 'Endereço copiado' : 'Copiar endereço'}
              </Button>
            </Box>
          </Alert>
        )}
        <Passo numero={1}>
          Toque em <b>Compartilhar</b> <IosShareRounded sx={{ fontSize: 18, verticalAlign: 'text-bottom' }} /> na
          barra do Safari (embaixo, ou no topo no iPad).
        </Passo>
        <Passo numero={2}>
          Role a lista e toque em <b>Adicionar à Tela de Início</b>{' '}
          <AddBoxOutlined sx={{ fontSize: 18, verticalAlign: 'text-bottom' }} />.
        </Passo>
        <Passo numero={3}>
          Toque em <b>Adicionar</b>. O ícone do SIAC aparece na tela inicial.
        </Passo>
        <Passo numero={4}>
          Abra o SIAC <b>pelo ícone</b>, entre e espere a sincronização terminar — a partir daí ele funciona
          também sem internet.
        </Passo>
        <Typography variant="caption" color="text.secondary">
          Use sempre pelo ícone: os dados offline do app instalado ficam separados dos do Safari.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Entendi</Button>
      </DialogActions>
    </Dialog>
  );
};
